<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel :title="title">
         <CodeCreate v-if ='$store.state.isEditor' v-bind:codes="$constants.codes" v-bind:options="options" v-bind:data="data" slot="action"/>

         <div slot="top">
          <v-tabs @change="tabChanged" show-arrows>
            <v-tab v-for="codeSet in $constants.codes" v-bind:key="codeSet.code">
              {{ codeSet.v }}
            </v-tab>
            <!-- <v-tabs-items @change="tabChanged"> -->
            <v-tab-item v-for="codeSet in $constants.codes" v-bind:key="codeSet.code">
              <div style='text-align:left;margin-top:1em'>
               
                <v-layout row justify-start v-for="code in data[codeSet.code]"  v-bind:key="code.id">
                  <v-flex xs3 mx-2>{{code.v}} </v-flex>
                  <v-flex xs2 mx-2>
                    <span v-if="counts[code.id] > 0">
                      <router-link :to="{ path: '/people', query: { relType: codeSet.code,                         
                        relValue: code.id, description: encodeURIComponent(codeSet.v + ' of ' + code.v) }}">
                        Show {{ counts[code.id] }}
                        <span v-if="counts[code.id] > 1">people</span>
                        <span v-else>person</span>
                      </router-link>
                    </span>
                    <span v-else>[ unused ]</span>
                  </v-flex>
                  <v-flex xs2 mx-2>
                    <v-btn v-if ='$store.state.isEditor' small  @click="editCode(code.id)">Edit</v-btn>
                  </v-flex>
                </v-layout>

                <!--
                <div v-for="code in data[codeSet.code]"  v-bind:key="code.id" style='width:30em;'>
                  <div style='width:15em;height:3em;float:left'>
                    {{code.v}} 
                  </div>
                  <div style="float:left; width:15em;height:3em;text-align:right">
                    <span v-if="counts[code.id] > 0">
                      <router-link :to="{ path: '/people', query: { relType: codeSet.code, relValue: code.id, description: codeSet.v + ' of ' + code.v }}">
                        Show {{ counts[code.id] }}
                        <span v-if="counts[code.id] > 1">people</span>
                        <span v-else>person</span>
                      </router-link>
                    </span>
                    <span v-else>
                      [ unused ]
                    </span>
                    <v-btn v-if ='$store.state.isEditor' small  @click="editCode(code.id)">Edit</v-btn>
                  </div>
                </div>
                -->
              </div>
            </v-tab-item>
            <!-- </v-tabs-items> -->
          </v-tabs>
        </div>         
      </panel>            
    </v-flex>
    <CodeEdit v-if ='$store.state.isEditor' v-bind:codes="$constants.codes" v-bind:options="options" v-bind:data="data"/>
  </v-layout>
</template>

<script>
import CodeService from "@/services/CodeService" ;
import Panel from "@/components/Panel" ;
import CodeCreate from "./CodeCreate" ;
import CodeEdit from "./CodeEdit" ;

export default {
  components: {
    Panel, CodeCreate, CodeEdit
  },
  data () {
    return {
      data: {},
      counts: {},
      options: {
        currentCode: 0,
        currentCodeType: null,
        currentId: -1,
        currentName: '',
        showEditDialog: false
      },
      title: "Loading Codes.."
    } ;
  },
  methods: {

    editCode (id) {
      // alert("edit " + id) ;
      this.options.currentId = id ;
      this.options.currentName = "??" ;
      this.options.currentCodeType = this.$constants.codes[this.options.currentCode].code ;
      const arr = this.data[this.options.currentCodeType] ;
      for (let i = 0 ; i < arr.length ; i++) {
        if (arr[i].id === id) {
          this.options.currentName = arr[i].v ;
          break ;
        }
      } 
      this.options.showEditDialog = true ;
    },

    tabChanged (tabNum) {
      console.log(" tab was changed" + tabNum + this.$constants.codes[tabNum].v) ;
      this.options.currentCode = tabNum ;
      this.generateTitle() ;
    },
    generateTitle () {
      this.title = "Codes for " + this.$constants.codes[this.options.currentCode].v ;
    },
    renderLink (codeSet, code) {
      return "<a href='aaa'>Link to " + codeSet.v + " reltype= id " + code.id + "</a>" ;
    },
    async showPeople () {  

      const route = {
        name: 'people',
        query: { }
      }
      // TODO if (this.name.length > 0) route.query.name = this.name ;
      this.$router.push(route) ;
    },

    async readData () {
      // const result = await CodeService.index() ;
      // this.data = result.data ;
      // const codePromise = CodeService.index() ;
      const countPromise = CodeService.counts() ;
      this.data = await this.$getCodes(true) ; // (await codePromise).data ;
      console.log("codes " + JSON.stringify(this.data)) ;
      this.counts = (await countPromise).data ;
    }
  },

  async mounted () {
    console.log("code mounted") ;
    await this.readData() ;
    this.generateTitle() ;
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Codes.vue